import React, { Component } from 'react';
import { Button, Checkbox, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';

import axios from 'axios';
import CourseExamsStatistic from '../Reports/ConstReports/CourseExamsStatistic';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';
import ExcelFile from 'react-data-export/dist/ExcelPlugin/components/ExcelFile';
import ExcelSheet from 'react-data-export/dist/ExcelPlugin/elements/ExcelSheet';


class CoursesPerCycle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            excelData: [],
            report: 1,
            academicYear: null,
            semester: null,
            orgUnit: null,

            studyProgramBasics: [],
            studyProgramBasicId: null,
            results: [],
            loader: false,
            archivedCB: false,
            activeCB: false,

            orgUnitFilter: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };

        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
            localStorage.setItem('activeRole', activeRole);
        }

        if (localStorage.getItem('orgUnit')) {
            let orgUnit = localStorage.getItem('orgUnit');
            window.localStorage.clear();
            localStorage.setItem('orgUnit', orgUnit);
            localStorage.setItem('activeRole', activeRole);
        }
        localStorage.setItem('activeRole', activeRole);
        this.getSPB();
    }


    getSPB(orgUnitId) {
        let obj = {};
        axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `study-programs/basic/${this.state.orgUnit}`
            : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'orgUnit') {
            let obj = {};
            axios.post(`study-programs/basic/${value}`, { ...obj })
                .then(res => {
                    const studyProgramBasics = res.data.map((el) => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                        description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                    })).filter(e => e.studyProgramBasic.archived === false);

                    this.setState({ studyProgramBasics });
                })
                .catch(err => {
                    console.log('Failed to fetch study program basics. ', err);
                });
            this.getData(-1, -1, value);
        }


        if (name === 'studyProgramBasicId') {
            if (value === '') this.getData(); else this.getData(value);
        }
        this.setState({
            [name]: value
        });
    }

    getData(studyProgramBasicId = -1, archived = -1, orgUnit = this.state.orgUnit) {
        this.setState({ loader: true });
        axios.get(this.state.orgUnitFilter ? `reports/number-of-courses-per-study-cycle/${archived}/${orgUnit}/${studyProgramBasicId}`
            : `reports/number-of-courses-per-study-cycle/${archived}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loader: false,
                    data: res.data,
                    excelData: res.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfCourses }
                    ]))
                });
                console.log('data', this.state.data);
            });
    }

    getResults(results) {
        if (results.length === 0) {
            this.setState({
                excelData: this.state.students.map(el => ([
                    { value: el.studyCycleName },
                    { value: el.numberOfCourses },
                ]))
            });
        } else {
            this.setState({
                results,
                excelData: results.map(el => ([
                    { value: el.studyCycleName },
                    { value: el.numberOfCourses },
                ]))
            });
        }
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    render() {
        const multiDataSet = [
            {
                columns: [
                    { title: 'Ciklus', width: { wpx: 200 } },
                    { title: 'Broj predmeta', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];
        const {
            data, loader, studyProgramBasicId
        } = this.state;
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        {this.state.orgUnitFilter && <Form.Field>
                            <Form.Dropdown
                                clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.orgUnit}
                                onChange={this.handleInputChange}
                                name="orgUnit"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                required
                                selection
                                error={this.state.organizationalUnitEntityError}
                            />
                        </Form.Field>}
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    {/*<Form.Group>*/}
                    {/*    <Form.Field >*/}
                    {/*        <Checkbox*/}
                    {/*            checked={this.state.archivedCB}*/}
                    {/*            label="Samo arhivirani predmeti"*/}
                    {/*            value={this.state.archivedCB}*/}
                    {/*            onChange={(e) => {*/}
                    {/*                this.setState({ archivedCB: !this.state.archivedCB, activeCB: this.state.archivedCB = true ? false : false }, () => {*/}
                    {/*                    this.getData(this.state.studyProgramBasicId ? this.state.studyProgramBasicId : -1, this.state.archivedCB ? 1 : -1);*/}
                    {/*                });*/}
                    {/*            }}*/}
                    {/*        />*/}
                    {/*    </Form.Field>*/}
                    {/*</Form.Group>*/}
                    {/*<Form.Group>*/}
                    {/*    <Form.Field >*/}
                    {/*        <Checkbox*/}
                    {/*            checked={this.state.activeCB}*/}
                    {/*            label="Samo aktivni predmeti"*/}
                    {/*            value={this.state.activeCB}*/}
                    {/*            onChange={(e) => {*/}
                    {/*                this.setState({ activeCB: !this.state.activeCB, archivedCB: this.state.activeCB = true ? false : false }, () => {*/}
                    {/*                    this.getData(this.state.studyProgramBasicId ? this.state.studyProgramBasicId : -1, this.state.activeCB ? 0 : -1);*/}
                    {/*                });*/}
                    {/*            }}*/}
                    {/*        />*/}
                    {/*    </Form.Field>*/}
                    {/*</Form.Group>*/}
                </Form>

                <br /><br /><br />

                {loader ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div>
                    :
                    <div>

                    {data.length ? <Table celled selectable compact>

                            <Table.Header>
                            <Table.Row>
                                    <Table.HeaderCell colSpan={5} >
                                    <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['studyCycleName']} />
                                        </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                            <ExcelFile
                                                    filename="Ukupan broj predmeta po ciklusu"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                </ExcelFile>

                                        </Grid.Column>
                                        </Grid>
                                </Table.HeaderCell>
                                </Table.Row>
                            <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Ciklus</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Broj predmeta </Table.HeaderCell>

                                </Table.Row>
                        </Table.Header>
                            <Table.Body> {data.map((el, index) =>
                                (<Table.Row key={el.id}>

                                    <Table.Cell verticalAlign="middle" width="1">  {index + 1}. </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyCycleName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.numberOfCourses}</Table.Cell>

                                </Table.Row>))}
                        </Table.Body>
                        </Table> : 'Nema podataka.'}
                </div>


                }

            </div>
        );
    }
}

export default CoursesPerCycle;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/CoursesPerCycle.js